import { isset } from 'src/util/Util';
import i18n from 'src/i18n';
import SweetAlert from 'src/class/Alerts';
import UtilFactory from 'src/factories/UtilFactory';

const mixinForm = {
  data() {
    return {
      initialModel: {},
    };
  },
  methods: {
    /**
     * Este método sirve para colocarle el seleccionar todos
     * a un select multiple
     * @param {*} data
     * @param {*} nameKey
     * */
    getConcatAll(nameKey, nameLabel) {
      let concat = {};
      if (!nameKey) {
        concat = { id: 0, name: nameLabel };
      } else {
        concat['id'] = 0;
        concat[nameKey] = nameLabel;
      }

      return concat;
    },
    /**
     * Este método sirve para colocarle el seleccionar todos
     * a un select multiple
     * @param {*} data
     * @param {*} nameKey
     * @param {String} nameLabel
     * @returns
     */
    concatAll(
      data,
      nameKey = null,
      nameLabel = i18n.t('uti.mixinMasters.selectAll')
    ) {
      return [this.getConcatAll(nameKey, nameLabel)].concat(data);
    },

    /**
     * Este método sirve para colocarle el seleccionar todos
     * a un select multiple de lotes simples
     * @param {*} data
     * @param {*} nameKey
     * @param {*} nameLabel
     * @returns
     */
    concatAllLots(
      data,
      nameKey = null,
      nameLabel = i18n.t('uti.mixinMasters.selectAll')
    ) {
      return [this.getConcatAll(nameKey, nameLabel)].concat(
        data.map((el, index) => {
          return {
            id: index + 1,
            name: el,
          };
        })
      );
    },

    /**
     * Seleccionar todos los elementos de un select multiple
     * @param {*} model
     * @param {*} array_data
     * @param {*} scope
     */
    selectAllFromSelect(model, array_data, scope = null) {
      let util_selects = new UtilFactory(this).getUtilObject('select');
      util_selects.selectAllFromSelect(model, array_data, scope);
    },

    /**
     * Seleccionar todos los elementos de un select multiple de lotes simples
     * @param {*} model
     * @param {*} array_data
     * @param {*} scope
     */
    selectAllFromSelectLots($event, model, array_data, scope = null) {
      let utilSelects = new UtilFactory(this).getUtilObject('select');
      utilSelects.selectAllFromSelectLots($event, model, array_data, scope);
    },

    /**
     * Autogenerador de códigos para los registros de base de datos
     * @param {String} module
     * @param {Array} tableData
     * @param {String} field
     */
    async codeGenerator(module, tableData, field = 'code') {
      const codesOn = tableData
        .filter(
          (data) =>
            (data && data.hasOwnProperty('code') && data.code !== null) ||
            (data && !data.hasOwnProperty('code'))
        )
        .map((data) => {
          if (data.hasOwnProperty('code'))
            return Number(String(data.code).replace(/\D/g, ''));
          else return Number(data.replace(/\D/g, ''));
        })
        .sort((a, b) => b - a)
        .filter((code) => !isNaN(code));

      return await SweetAlert.default(
        '',
        i18n.t('common_words.generate_code'),
        i18n.t('common_words.generate_code_response')
      ).then((result) => {
        if (result.value) {
          const code = this.generateCode(
            module,
            codesOn && codesOn.length > 0 ? codesOn[0] : 0
          );

          if (field) this.$set(this.model, field, code);

          return code;
        }
      });
    },

    /**
     * Método para generar el código
     * @param {String} module
     * @param {Number[]} consecutive
     * @returns
     */
    generateCode(module, consecutive) {
      const words = module.split(' ');
      const initials = words.map((word) => word[0]);

      const length = 4;
      let number = Number(consecutive) + 1;
      const numberToRepeat = length - number.toString().length;
      let zeros = '';
      if (numberToRepeat > 0) zeros = '0'.repeat(numberToRepeat);

      return `${initials.join('')}${zeros + number.toString()}`;
    },

    /**
     * Obtener el mensaje del error de validación
     * @param {String} fieldName
     * @param {Boolean} useKey
     * @param {String|Number|Object} appendToMessage
     * @returns
     */
    getError(fieldName, useKey = false, appendToMessage = '') {
      if (this.$refs[fieldName]) {
        let requireds = this.$refs[fieldName].$el.getElementsByTagName('input');
        for (let item of requireds) {
          item.focus();
        }
      }

      if (useKey) {
        const valueKey = i18n.t(fieldName);
        if (typeof this.errors.first(fieldName) === 'string') {
          let msg = this.errors
            .first(fieldName)
            .replace(fieldName, `${valueKey}`);

          if (typeof appendToMessage === 'object' && appendToMessage !== null) {
            msg = this.multipleReplace(msg, appendToMessage);
          } else {
            msg += ` ${appendToMessage}`;
          }

          return msg;
        }
      }

      return this.errors.first(fieldName);
    },

    /**
     * Obtener el mensaje del error de validación para campos individuales o arreglos.
     * @param {String} fieldName - Nombre base del campo (ejemplo: 'gross_weight').
     * @param {Boolean} useKey - Indica si se debe traducir el nombre del campo.
     * @param {Number} [index] - Índice del campo si se trata de un arreglo.
     * @param {String|Number|Object} appendToMessage - Información adicional para agregar al mensaje.
     * @returns {String|null} - Mensaje de error formateado o null si no hay error.
     */
    getFieldErrorByIndex(
      fieldName,
      useKey = false,
      index = null,
      appendToMessage = ''
    ) {
      const dynamicFieldName =
        index !== null ? `${fieldName}_${index}` : fieldName;

      if (this.$refs[dynamicFieldName]) {
        const requireds =
          this.$refs[dynamicFieldName].$el.getElementsByTagName('input');
        for (let item of requireds) {
          item.focus();
        }
      }

      const errorMessage = this.errors.first(dynamicFieldName);
      if (!errorMessage) {
        return null;
      }

      if (useKey) {
        const valueKey = i18n.t(fieldName);
        let formattedMessage = errorMessage.replace(dynamicFieldName, valueKey);

        if (typeof appendToMessage === 'object' && appendToMessage !== null) {
          formattedMessage = this.multipleReplace(
            formattedMessage,
            appendToMessage
          );
        } else {
          formattedMessage += ` ${appendToMessage}`;
        }

        return formattedMessage;
      }

      return errorMessage;
    },

    /**
     * Reemplaza múltiples ocurrencias en una cadena.
     * @param {String} text
     * @param {Object} toReplace
     * @returns
     */
    multipleReplace(text, toReplace) {
      let result = text;

      for (const [search, replaceWith] of Object.entries(toReplace)) {
        result = result.split(search).join(replaceWith);
      }

      return result;
    },

    /**
     * Asigna elementos a un elemento de formulario modelo en función del tipo y los elementos de datos especificados.
     * Este método filtra y asigna elementos comerciales a partir de los datos del usuario autenticado,
     * excluyendo una empresa específica con id 1 para los que no son superadministradores.
     *
     * @param {Number} type
     * @param {any} modelFormElement
     * @param {Array} dataElements
     * @returns {any}
     */
    selectElementsAsignFromModel(type, modelFormElement, dataElements = []) {
      let elements = [];
      const dataAuth = this.$store.state.auth;

      if (!dataAuth.permissions.includes('Super Administrador'))
        elements = dataAuth.user.business.filter((item) => item.id != 1);
      else elements = dataAuth.user.business;

      if (dataElements.length > 0) {
        let resultForEach = [];
        dataElements.forEach((element) => {
          const result = elements.find((business) => business.id == element.id);
          if (result) resultForEach.push(result);
        });

        elements = resultForEach;
      }

      switch (type) {
        case 0:
          if (elements.length == 1) {
            modelFormElement = elements[0].id;
          }
          break;
        default:
          modelFormElement = elements.map((business) => business.id);
          break;
      }

      return modelFormElement;
    },

    /**
     * Maneja el evento de clic en un botón de generación de código.
     * Comprueba si hay un 'tableCode' disponible en sessionStorage,
     * y si es así, llama al método 'codeGenerator' para generar un código.
     *
     * @param {String} label
     * @param {Object} indexToValidate
     * @param {String} indexToValidate.index
     * @param {Boolean} indexToValidate.customField
     * @param {Boolean} otherValidation
     */
    handleClickOnCode(
      label,
      indexToValidate = { index: 'code', customField: false },
      otherValidation = false
    ) {
      let tableCode = sessionStorage.getItem('tableCode');
      if (tableCode) {
        tableCode = Object(JSON.parse(tableCode));
        if (!isset(this.model[indexToValidate.index]) && !otherValidation)
          if (indexToValidate.customField)
            this.codeGenerator(i18n.t(label), tableCode);
          else
            this.codeGenerator(i18n.t(label), tableCode, indexToValidate.index);
      }
    },
  },
  beforeMount() {
    this.initialModel = { ...this.model };
  },
};

export default mixinForm;
